import LocationCheckbox from './LocationCheckbox';

export default LocationCheckbox;
